import { OrderTemplate } from "../../../api/types/order-template";
import { FormErrors } from "../../FieldError";

export const validate = (template: OrderTemplate): [boolean, FormErrors<OrderTemplate>] => {
  let errors: FormErrors<OrderTemplate> = {}

  if (!template.name) {
    errors.name = "Název je povinné pole"
  }

  return [Object.keys(errors).length === 0, errors]
}
